import { zergApi } from "@/service/zerg";

class SettingVariableBonusService {

    async createOrUpdate(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/variable-bonus/create-or-update', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    
    async list(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/variable-bonus/list', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async delete(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/variable-bonus/delete', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async tracking(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/variable-bonus/tracking', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getServiceTypes() {
        try {
            const { data } = await zergApi.post('setting/payroll/variable-bonus/get-service-types');
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new SettingVariableBonusService();
